import { ModalComponentConfig } from '@rappider/rappider-components/utils';

export const WorkflowDiagramInfoModalConfig: ModalComponentConfig = {
  title: 'Info Messages',
  okText: null,
  cancelText: null,
  footer: null
};
